import { Button } from 'blaze-ui/Button'
import { TLUnknownShape } from '@tldraw/tldraw'
import { Layers3 } from 'blaze-ui/icons'
import { useRootStore } from 'stores/RootStore'
import { useUnflattenImage } from 'hooks/queries/designs/useUnflattenImage'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { ImageShape } from 'components/VisualStudioPlayground/Shapes/ImageShape/Types'
import { observer } from 'mobx-react-lite'

interface Props {
  selectedShape: ImageShape
}

const UnflattenButton = observer(({ selectedShape }: Props) => {
  const { designStore } = useRootStore()
  const designId = designStore?.fileId

  const { mutate: unflatten, isLoading } = useUnflattenImage(
    { designId: designId ?? '' },
    {
      onSuccess: (data) => designStore?.startUnflatten(data.batch_id, selectedShape.id),
      onError: () => {
        showToastMessage('Failed to unflatten image. Please try again.', 'error')
      },
    },
  )

  const isProcessing = isLoading || !!designStore?.isUnflattening

  return (
    <Button
      variant="secondary"
      onPress={() => designId && unflatten({ shapeId: selectedShape.id })}
      frontIcon={Layers3}
      isDisabled={isProcessing || !designId}
    >
      {isProcessing ? 'Extracting…' : 'Extract Layers'}
    </Button>
  )
})

interface ContainerProps {
  selectedShape: TLUnknownShape
}

const UnflattenButtonContainer = ({ selectedShape }: ContainerProps) => {
  if (selectedShape.type !== 'image') return null

  return <UnflattenButton selectedShape={selectedShape as ImageShape} />
}

export { UnflattenButtonContainer as UnflattenButton }
